import { getConfig } from '@amzn/aws-howser-client-config';
import { Helmet } from 'react-helmet';

export const CwRUMScript = () => {
  return (
    <Helmet>
      <script>
        {`
           (function (n, i, v, r, s, c, x, z) {
             x = window.AwsRumClient = { q: [], n: n, i: i, v: v, r: r, c: c };
             window[n] = function (c, p) {
               x.q.push({ c: c, p: p });
             };
             z = document.createElement('script');
             z.async = true;
             z.src = s;
             document.head.insertBefore(z, document.getElementsByTagName('script')[0]);
           })(
             'cwr',
             '${getConfig('howserService')?.cwRUMAppMonitorId}',
             '1.0.0',
             'us-east-1',
             'https://client.rum.us-east-1.amazonaws.com/1.5.x/cwr.js',
             {
               sessionSampleRate: 1,
               guestRoleArn: "arn:aws:iam::${
                 getConfig('howserService')?.serviceAccount
               }:role/AwsHowser-RUM-Monitor-us-east-1-${getConfig('howserService')?.serviceAccount}-Unauth",
               identityPoolId: '${getConfig('howserService')?.cwRUMIdentityPoolId}',
               endpoint: 'https://dataplane.rum.us-east-1.amazonaws.com',
               telemetries: ['performance', 'errors', 'http'],
               allowCookies: true,
               enableXRay: true,
             }
           );
        `}
      </script>
    </Helmet>
  );
};
